// 存储在 localStorage 中的 key

// 前缀
// 全局前缀
export const GLOBAL_PREFIX = 'G';

// 做题时 go 接口返回信息，用于产品需求 记录用户上报题目信息
export const GO_INFO = 'go';
// 练习信息
export const HW_INFO = 'hwInfo';

// 老师布置课程信息
export const GET_COURSE_TREE = 'getCourseTree';

// 老师布置知识点查看
export const GET_KNOWLEDGE_LIST = 'getKnowledgeList';

// 老师布置信息
export const HOMEWORK_INFO = 'homeworkInfo';

// 老师查看信息
export const GET_USER_BY_DID = 'getUserByDid';

// 老师查看信息请求前
export const GET_USER_BY_DID_REQUEST = 'getUserByDid';

export const FEEDBACK = 'feedback';
//  缓存 store
export const G_STORE_AMT = 'G_STORE_AMT';
export const G_STORE_MT = 'G_STORE_MT';
